import { ReviewState, ReviewTypeEnum } from '.';

export const initialState: ReviewState = {
  List: [],
  loading: false,
  buttonLoading: false,
  isFileUpload: false,
  search: '',
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: '',
  orderDir: '',
  form: {
    _id: '',
    name: '',
    linkUrl: '',
    image: '',
    reviewType: ReviewTypeEnum.REVIEW,
    isActive: true,
    description: "",
    createdAt: '',
    updatedAt: ''
  }
};
